import { Component, OnInit, Input, ViewChild, Output, EventEmitter, OnDestroy} from '@angular/core';
import { BaseControl, ConfirmComponent, SedeEmpresa, Const } from '@app/shared';
import { LocalDataSource } from 'ng2-smart-table';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService, GlobalInfoService } from '@app/core';
import { Subject } from 'rxjs';
import { ManagementConsecutiveActFormService } from './shared/management-consecutive-act-form.service';
import { ManagementConsecutiveActDataService } from './shared/management-consecutive-act-data.service';
import { ManagementConsecutiveActConfigService } from './shared/management-consecutive-act-config.service';
import { ConsecutiveAtc } from '@app/shared/models/consecutive-atc.models';

@Component({
  selector: 'iw-consecutive-act-management',
  templateUrl: './management-consecutive-act.component.html',
  styleUrls: ['./management-consecutive-act.component.scss'],
  providers: [
    ManagementConsecutiveActFormService,
    ManagementConsecutiveActDataService
  ]
})
export class ManagementConsecutiveActComponent implements OnInit, OnDestroy {

  // Define la accion a realizar en el formulario
  actionForm = '';
  // Pregunta de la modal de confirmaciones
  question = '';
  // Define cuando mostrar la tabla principal o el formulario
  formOpen = false;
  // Define si el consecutivo en accion es para editar o agregar
  consecutiveEdit = true;
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    created: false,
    review: false,
    update: false,
    delete: false
  };
  // Configuracion de la tabla
  settings = {};
  // Datos para llenar la tabla
  sourceData: ConsecutiveAtc[] = [];
  // Contiene el consecutivo seleccionado
  consecutiveSelect: ConsecutiveAtc;
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;

  constructor(
    private smfs: ManagementConsecutiveActFormService,
    private smds: ManagementConsecutiveActDataService,
    private toastr: ToastrService,
    private as: AuthenticationService,
    private gis: GlobalInfoService,
    ) { }

  ngOnInit() {
    // Modificando el titulo del modulo
    this.gis.set({ title: 'Administración consecutivos de actas' });
    // Determina los permisos del usuario en sesion
    this.activateAction.created = this.as.confirmPermission(
      Const.types_permissions.adminConsecutiveAct,
      Const.types_action_permissions.created
    );
    this.activateAction.update = this.as.confirmPermission(
      Const.types_permissions.adminConsecutiveAct,
      Const.types_action_permissions.update
    );
    this.activateAction.delete = this.as.confirmPermission(
      Const.types_permissions.adminConsecutiveAct,
      Const.types_action_permissions.delete
    );
    const configTable = new ManagementConsecutiveActConfigService();
    this.settings = configTable.settings;

    configTable.accion.subscribe((res: any) => {
      this.defineActionCondictions(res.action, res.data);
    });
    this.getConsecutives();
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
    this.sourceData = [];
    this.consecutiveSelect = null;
  }

  /**
   * Define acción a realizar
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof ManagementConsecutiveActComponent
   */
  defineActionCondictions(action: 'add' | 'update' | 'delete' = 'add', data?: any) {
    switch (action) {
      case 'add':
        if (this.activateAction.created) {
          this.formOpen = true;
          this.consecutiveEdit = false;
          this.actionForm = 'Agregar';
          this.controls = this.smfs.getFormConsecutive();
        } else {
          this.toastr.error('Usted no posee permisos para agregar las consecutivos de actas', 'Permiso denegado');
        }
        break;
      case 'update':
        if (this.activateAction.update) {
          this.formOpen = true;
          this.consecutiveEdit = true;
          this.actionForm = 'Modificar';
          this.consecutiveSelect = data;
          this.controls = this.smfs.getFormConsecutive(this.consecutiveSelect);
        } else {
          this.toastr.error('Usted no posee permisos para modificar las consecutivos de actas', 'Permiso denegado');
        }
        break;
      case 'delete':
        if (this.activateAction.delete) {
          this.consecutiveSelect = data;
          this.question = '¿Realmente desea eliminar el rango de consecutivos?';
          this.confirm.open();
        } else {
          this.toastr.error('Usted no posee permisos para eliminar las consecutivos de actas', 'Permiso denegado');
        }
        break;
    }
  }

  /**
   * Recibe respuesta del modal de confirmaciones
   *
   * @param {boolean} res
   * @memberof ManagementConsecutiveActComponent
   */
  actionComfirm(res: boolean) {
    if (res) {
      this.deleteConsecutive();
    }
    this.question = '';
  }

  /**
   * Cerrar el formulario
   *
   * @memberof ManagementConsecutiveActComponent
   */
  closeFormConsecutive() {
    this.actionForm = '';
    this.question = '';
    this.formOpen = false;
    this.consecutiveEdit = false;
    this.consecutiveSelect = null;
  }

  /**
   * Agregar o editar un rango de consecutivos
   *
   * @param {*} data
   * @memberof ManagementConsecutiveActComponent
   */
  sended(data: any) {
    if (data) {
      let consecutive: ConsecutiveAtc = new ConsecutiveAtc();
      consecutive = {
        consecutivo_inicial : data.consecutivo_inicial,
        consecutivo_final : data.consecutivo_final
      };

      if (this.consecutiveSelect) {
        this.smds.updateConsecutive(this.consecutiveSelect.id, consecutive).then(() => {
          this.closeFormConsecutive();
          this.getConsecutives();
        });
      } else {
        this.smds.addConsecutive(consecutive).then(() => {
          this.closeFormConsecutive();
          this.getConsecutives();
        });
      }

    }
  }

   /**
   * traer listado de rangos de consecutivos
   *
   * @private
   * @memberof ManagementConsecutiveActComponent
   */
   private getConsecutives() {
    this.smds.getConsecutives().subscribe((data: ConsecutiveAtc[]) => {
      this.sourceData = data;
      });
  }


  /**
   * Eliminar un rango de consecutivos
   *
   * @private
   * @memberof ManagementConsecutiveActComponent
   */
  private deleteConsecutive() {
    this.smds.deleteConsecutive(this.consecutiveSelect.id).then(() => {
      this.closeFormConsecutive();
      this.getConsecutives();
    }).catch(() => {
      this.closeFormConsecutive();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-consecutive-act/management-consecutive-act.component.ts